import type { WbSession } from '@weberus/session';
import { atom } from 'jotai';

// 동의 여부 상태
export const agreementsAtom = atom<WbSession['agreements']>();

// hashedMemberNo
export const hashedMemberNoAtom = atom<string | undefined>(undefined);

// 회원의 위치 정보 동의 여부
export const isLocationAgreedAtom = atom<boolean>(false);
